export enum OtpModeEnum {
  VERIFICATION = 'verification',
  LOGIN = 'login',
  FINE = 'fine',
  FORGOT_PASSWORD = 'forgot-password',
}
